// composables/useNovaPoshta.js
import { useRuntimeConfig } from "#imports";
import { useNovaPoshtaMock } from "./useNovaPoshtaMock";
import { useNovaPoshtaReal } from "./useNovaPoshtaReal";

export function useNovaPoshta() {
  const cfg = useRuntimeConfig();
  return cfg.public?.npEnabled ? useNovaPoshtaReal() : useNovaPoshtaMock();
}
